export enum TableMenuActionEnums {
    UNKNOWN = 0,
    /**
     * Fix the clicked row
     */
    FIX_ROW,
    /**
     * Fix selected column (not used yet)
     */
    FIX_COLUMN,
    /**
     * Edit the selcted dataSet/row
     */
    EDIT_LINE,
    /**
     * Delete the selected dataSet/row
     */
    DELETE_LINE,
    /**
     * Clone selected row as new dataSet
     */
    CLONE_LINE,
    /**
     * DEPRICATED
     * Clone test series
     */
    CLONE_TEST_SERIES,
    /**
     * DEPRICATED
     */
    ADD_DATA_TO_LINE,
    /**
     * Generate a settings report from selected row
     */
    SETTINGS_REPORT,
    /**
     * Export all dataSet of test series to csv
     */
    EXPORT_TEST_SERIES_CSV,
    /**
     * Export all dataSet of test series to excel
     */
    EXPORT_TEST_SERIES_EXCEL,
    /**
     * Edit the value inline
     */
    EDIT_VALUE,
    /**
     * Change the backgoruind color of the table cell
     */
    COLOUR_FIELD,
    /**
     * Clear all colored cells and unfix all fixed items
     */
    CLEAN_ALL_MARKS,
    /**
     * Copy cell valuze to clipboard
     */
    COPY_FOR_QUICK_PASTE,
    /**
     * Unfix selected fixed row
     */
    UNFIX_ROW,
    /**
     * Copy Tab ID to Clipboard
     */
    COPY_TAB_ID,
    /**
     * Copy direct link with Tab ID to Clipboard
     */
    COPY_TAB_ID_URL,
    /**
     * Previews dataset/row
     */
    PREVIEW_DATASET,
}

export enum TableMenuActionColorEnums {
    UNMARK = 0,
    ORANGE = 1,
    GREY = 2,
    BLUE = 3,
}
